/** Fallback when super admin (angel@reviewboost24.com) profile has null business_id after DB link */
export const FALLBACK_SUPER_ADMIN_BUSINESS_ID = "3ef71dc6-60ec-427f-a47a-56c5d23c87e8";

/** Angel/admin shared business — reviewboosts.services must NEVER use this. */
export const ANGEL_BUSINESS_ID = "3ef71dc6-60ec-427f-a47a-56c5d23c87e8";

/** Dedicated business for geoffery.chola@gmail.com — fresh, private data. Must match DB migration. */
export const GEOFFERY_CHOLA_BUSINESS_ID = "a7f3c2e1-9b4d-4f8a-b6e0-2c5d1a9f8e3b";

/** Canonical production domain — the only/main domain for the app.
 * Set VITE_SITE_URL in Vercel/.env to override (e.g. https://app.reviewboost24.com). */
export const PRODUCTION_ORIGIN =
  (typeof import.meta !== "undefined" && (import.meta as unknown as { env?: { VITE_SITE_URL?: string } }).env?.VITE_SITE_URL) ||
  "https://app.reviewboost24.com";

/** Production auth callback used by Supabase for OAuth and email confirmation (PKCE). */
export const AUTH_CALLBACK_URL_PRODUCTION = `${PRODUCTION_ORIGIN}/auth/callback`;

/** Auth callback URL: use production domain whenever not on localhost so Google/email OAuth always redirects to app.reviewboost24.com/auth/callback. */
const IS_LOCALHOST = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
export const AUTH_CALLBACK_URL = IS_LOCALHOST
  ? `${window.location.origin}/auth/callback`
  : AUTH_CALLBACK_URL_PRODUCTION;
